import { GiftSubscriptionLandingPage, RepeatableComponent } from '../../types/GiftSubscriptionLandingPage'
import { absoluteImageUrl } from '../utils/environment'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const fromStrapiGiftSubscriptionLandingPage = (strapiData: any): GiftSubscriptionLandingPage => {
    const { attributes: { title, description, bannerImage, repeatableContent, redemptionLandingBanner, redemptionLandingTitle, redemptionLandingDescription, redemptionLandingRepeatable } } = strapiData

    const mappedRepeatableContent: RepeatableComponent[] = repeatableContent.map((item: { thumbnail: { data: { attributes: { url: string } } } }) => ({
        ...item,
        thumbnail: absoluteImageUrl(item.thumbnail.data.attributes.url),
    }))

    const mappedRedemptionLandingRepeatable: RepeatableComponent[] = redemptionLandingRepeatable.map((item: { thumbnail: { data: { attributes: { url: string } } } }) => ({
        ...item,
        thumbnail: absoluteImageUrl(item.thumbnail.data.attributes.url),
    }))

    const bannerImageURL = bannerImage.data.map((item: { attributes: { url: string } }) => ([
        absoluteImageUrl(item.attributes.url),
    ]))

    const redemptionLandingBannerImageURL = absoluteImageUrl(redemptionLandingBanner.data.attributes.url)

    return {
        title,
        description,
        bannerImageURL,
        repeatableContent: mappedRepeatableContent,
        redemptionLandingRepeatable: mappedRedemptionLandingRepeatable,
        redemptionLandingBannerImageURL,
        redemptionLandingTitle,
        redemptionLandingDescription,
    }
}

export { fromStrapiGiftSubscriptionLandingPage }